/* Sistema de galeria de la ficha, calcado del de Huel.
   No se reemplaza el carrusel del tema: el tema usa Swiper y deja la instancia
   colgada del nodo, asi que se le monta encima el cartel, los puntos y las
   flechas y se lo maneja por su propia API. Cambiar el carrusel entero seria
   romper el zoom, el lazy load y el soporte de video que ya funcionan. */
(function(){
  function armar(){
    /* La capa se cuelga del ENVOLTORIO DEL VISOR y no del contenedor de la
       columna: el contenedor tiene adentro tambien las tres fotos fijas, asi
       que mide toda la columna, y anclado ahi el indicador terminaba al pie de
       todo, tres pantallas abajo de la foto a la que corresponde. El envoltorio
       del visor mide exactamente la foto cuadrada. */
    var caja=document.querySelector('.product__media-wrapper .product__media-gallery-viewer-wrap')
          || document.querySelector('.product__media-wrapper .product__media-container');
    var sw=document.querySelector('.product__media-wrapper .swiper');
    if(!caja||!sw||!sw.swiper) return false;
    if(caja.querySelector('.rz-gal')) return true;
    var swiper=sw.swiper;

    /* ⚠️ LA FOTO QUE EXISTE SOLO PARA EL CHECKOUT SE SACA DE LA GALERIA.
       El checkout de Shopify no se programa: la miniatura la saca de la imagen
       de la variante, y una imagen de variante tiene que estar cargada en el
       producto. Cargada en el producto significa que aparece en el carrusel, y
       ahi no la queremos: las otras nueve son placas y una foto de estudio
       suelta en el medio se lee como un error.
       Entonces la foto se sube con el alt "rz-checkout" y aca se le saca la
       diapositiva ANTES de contar los puntos, asi el contador sigue dando
       nueve y no queda un punto que no lleva a ningun lado.
       Si algun dia se saca del producto, esto no hace nada y no molesta. */
    var sobra = sw.querySelectorAll('.swiper-slide img[alt="rz-checkout"]');
    for (var q=0; q<sobra.length; q++){
      var dia = sobra[q].closest ? sobra[q].closest('.swiper-slide') : null;
      if (dia && dia.parentNode) dia.parentNode.removeChild(dia);
    }
    if (sobra.length) swiper.update();

    /* EN CELU las tres fotos fijas entran como las tres ULTIMAS diapositivas de
       la galeria, no como bloque abajo. Abajo de 750 la columna es el carrusel a
       pantalla completa: colgarles un bloque apilado atras obliga a scrollear
       tres pantallas mas antes de llegar al precio. Como diapositivas se ven en
       el mismo gesto con el que ya se miran las fotos del producto.
       Se agregan ANTES de contar las diapositivas, si no los puntos quedan tres
       cortos. El flag evita que se dupliquen si armar() se reintenta. */
    /* El build de Swiper del tema NO trae el modulo de manipulacion: swiper.
       appendSlide no existe (verificado en el navegador, tiraba "is not a
       function" en loop). Las diapositivas se agregan al .swiper-wrapper a mano
       y despues se le avisa con update(). */
    var envoltura = sw.querySelector(':scope > .swiper-wrapper');
    if(window.matchMedia('(max-width:749px)').matches && envoltura && !sw.hasAttribute('data-rz-fotos')){
      var datos=window.RZ_PDP_FOTOS||[];
      for(var d=0; d<datos.length; d++){
        var f=datos[d];
        var base=f.src.indexOf('?')>-1 ? f.src+'&' : f.src+'?';
        var slide=document.createElement('div');
        slide.className='swiper-slide rz-gal__extra';
        var im=document.createElement('img');
        im.src=base+'width=900';
        im.srcset=base+'width=900 1x, '+base+'width=1400 2x';
        im.alt=f.alt||'';
        im.width=f.w; im.height=f.h;
        im.loading='lazy'; im.decoding='async';
        slide.appendChild(im);
        envoltura.appendChild(slide);
      }
      sw.setAttribute('data-rz-fotos','1');
      if(typeof swiper.update==='function') swiper.update();
    }

    var total=sw.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    if(total<1) return false;

    /* ── EL INDICADOR Y LAS FLECHAS, LOS DOS DEBAJO DE LA FOTO ──
       Tercera posicion y la definitiva (Mark, 20/09). El recorrido, para que no
       se vuelva a intentar: flechas sobre la foto a media altura —tapaban el
       texto de las placas—; despues tira de miniaturas; despues puntos sobre la
       foto abajo a la izquierda, que tapaban el logo de Mercado Libre en la
       primera placa y el final de la frase en la del testimonio.

       ⚠️ LA CONCLUSION, QUE ES LO QUE IMPORTA: sobre nuestras diapositivas NO
       SE PUEDE APOYAR NADA. Las de la referencia son fotos de producto con el
       centro y los rincones vacios; las nuestras son placas escritas de punta a
       punta, asi que cualquier cosa encima tapa algo en alguna. Los controles
       van afuera de la imagen. */
    var puntos=document.createElement('div');
    puntos.className='rz-gal__puntos';
    puntos.setAttribute('role','tablist');
    for(var i=0;i<total;i++){
      var p=document.createElement('button');
      p.type='button'; p.className='rz-gal__punto';
      p.setAttribute('aria-label','Ver imagen '+(i+1));
      p.setAttribute('data-i',i);
      puntos.appendChild(p);
    }
    var flechaSvg='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>';
    var izq=document.createElement('button');
    izq.type='button'; izq.className='rz-gal__flecha rz-gal__flecha--izq';
    izq.setAttribute('aria-label','Imagen anterior'); izq.innerHTML=flechaSvg;
    var der=document.createElement('button');
    der.type='button'; der.className='rz-gal__flecha rz-gal__flecha--der';
    der.setAttribute('aria-label','Imagen siguiente');
    der.innerHTML=flechaSvg.replace('M15 6l-6 6 6 6','M9 6l6 6-6 6');

    /* Los puntos y las flechas viven en la MISMA fila, debajo de la foto:
       indicador a la izquierda y flechas a la derecha. */
    var flechas=document.createElement('div');
    flechas.className='rz-gal__flechas';
    flechas.appendChild(izq); flechas.appendChild(der);

    var barra=document.createElement('div');
    barra.className='rz-gal__barra no-empty';
    barra.appendChild(puntos); barra.appendChild(flechas);
    caja.parentNode.insertBefore(barra, caja.nextSibling);

    function pintar(){
      var a=swiper.realIndex||0;
      var ps=puntos.querySelectorAll('.rz-gal__punto');
      for(var i=0;i<ps.length;i++) ps[i].setAttribute('aria-current', i===a?'true':'false');
      if(!swiper.params.loop){
        izq.disabled = a===0;
        der.disabled = a===total-1;
      }
    }
    izq.addEventListener('click',function(){ swiper.slidePrev(); });
    der.addEventListener('click',function(){ swiper.slideNext(); });
    puntos.addEventListener('click',function(e){
      var b=e.target.closest('.rz-gal__punto'); if(!b) return;
      var i=parseInt(b.getAttribute('data-i'),10);
      if(swiper.slideToLoop) swiper.slideToLoop(i); else swiper.slideTo(i);
    });
    swiper.on('slideChange',pintar);
    pintar();
    return true;
  }

  /* Las tres fotos fijas van DENTRO de .product__media-container, que es el
     mismo contenedor del carrusel. En Huel es asi: el bloque se llama
     PdpImageGallery y adentro tiene el carrusel y las tres fotos, todo junto,
     de modo que la columna entera se mueve como una sola pieza.
     El contenedor del tema trae la clase "sticky-element" pero calcula
     position:relative, asi que no hay pelea: la columna scrollea normal. */
  function fotos(){
    var caja=document.querySelector('.product__media-wrapper .product__media-container');
    var datos=window.RZ_PDP_FOTOS;
    if(!caja||!datos||!datos.length) return;
    if(caja.querySelector('.rz-fotos')) return;

    function foto(d){
      var f=document.createElement('figure');
      var i=document.createElement('img');
      /* El CDN de Shopify redimensiona por querystring. Se piden 1x y 2x sobre
         el ancho real que va a ocupar en la ficha, no sobre el de la foto. */
      var base=d.src.indexOf('?')>-1 ? d.src+'&' : d.src+'?';
      i.src=base+'width='+d.ancho;
      i.srcset=base+'width='+d.ancho+' 1x, '+base+'width='+(d.ancho*2)+' 2x';
      i.alt=d.alt||'';
      i.loading='lazy'; i.decoding='async';
      i.width=d.w; i.height=d.h;
      f.appendChild(i);
      return f;
    }

    var cont=document.createElement('div');
    cont.className='rz-fotos no-empty';

    var ancha=foto(datos[0]);
    ancha.className='rz-fotos__ancha';
    cont.appendChild(ancha);

    if(datos.length>1){
      var par=document.createElement('div');
      par.className='rz-fotos__par';
      for(var i=1;i<datos.length;i++) par.appendChild(foto(datos[i]));
      cont.appendChild(par);
    }
    caja.appendChild(cont);
  }
  fotos();

  /* El carrusel del tema se inicializa tarde, asi que se reintenta un rato. */
  if(!armar()){
    var n=0;
    var t=setInterval(function(){
      n++;
      if(armar() || n>40) clearInterval(t);
    },250);
  }
})();
